import bookaMeetingApi from "./request";
import { getCookie, setCookie } from './cookie';
import axios from 'axios';
import { baseURL } from './request';
import { logger } from '../utils/logger';
interface SignupData {
    email?: string;
    phoneNumber?: string;
    firstName: string;
    lastName: string;
  }
  
  interface SigninData {
    email?: string;
    phoneNumber?: string;
    otp: string;
  }
  interface ApiResponse {
    accessToken: string;
    refreshToken?: string;
    idToken?: string;
  }

interface EmbeddedSignupResponse {
  success: boolean;
  count: number;
  records: Array<{
    verified_name?: string;
    display_phone_number?: string;
    wabaId?: string;
    phoneNumberId?: string;
    businessId?: string;
    user_email?: string;
    login_number?: string;
    phoneNumber?: string;
    businessName?: string;
    status?: string;
    last_onboarded_time?: string;
    [key: string]: any;
  }>;
  searchPhone: string;
  normalizedPhone: string;
}

const signIn =  async (data:SigninData): Promise<ApiResponse | null | {}> => {
  try {
    const response = await bookaMeetingApi.request({
      url: "/signin",
      method: "POST",
      data,
    });
    // Store refresh token if available
    if (response.data && typeof response.data === 'object' && 'refreshToken' in response.data) {
      const refreshToken = (response.data as any).refreshToken;
      localStorage.setItem('refreshToken', refreshToken);
    }
    return response.data;
  } catch (error) {

  }

}

const signInWithPhone = async (phoneNumber: string, otp: string): Promise<ApiResponse | null | {}> => {
  try {
    const response = await bookaMeetingApi.request({
      url: "/signin",
      method: "POST",
      data: {
        phoneNumber,
        otp
      },
    });
    // Store refresh token if available
    if (response.data && typeof response.data === 'object' && 'refreshToken' in response.data) {
      const refreshToken = (response.data as any).refreshToken;
      localStorage.setItem('refreshToken', refreshToken);
    }
    return response.data;
  } catch (error) {
    // console.error('Phone signin error:', error);
    throw error;
  }
}

const signUp = async (data:SignupData) => {
    return await bookaMeetingApi.request({
        url: "/signup",
        method: "POST",
        data,
    });

}

const signUpWithPhone = async (phoneNumber: string, firstName: string = '', lastName: string = '') => {
    return await bookaMeetingApi.request({
        url: "/signup",
        method: "POST",
        data: {
            phoneNumber,
            firstName,
            lastName
        },
    });
}

const getEmbeddedSignupByPhone = async (display_phone_number: string): Promise<EmbeddedSignupResponse> => {
    const response = await bookaMeetingApi.requestWIthAuth({
        url: "/get-embedded-signup-by-phone",
        method: "POST",
        data: {
            display_phone_number
        },
    });
    return response.data as EmbeddedSignupResponse;
}

// Business Personality Settings API
interface BusinessPersonalitySettings {
  businessName: string;
  businessNumber: string;
  wabaId: string;
  mainSystemPrompt: string;
  defaultTone: 'professional' | 'friendly' | 'casual' | 'formal' | 'conversational';
  businessContext: {
    industry: string;
    businessRules: string[];
    customerProfile: string;
    brandVoice: string;
    answerStyle?: string;
    doNotAnswer?: string;
    questionsToAsk?: string;
  };
  languageSettings: {
    defaultLanguage: string;
    supportedLanguages: string[];
    autoDetectLanguage: boolean;
  };
  aiModelSettings: {
    defaultModel: string;
    defaultTemperature: number;
    defaultMaxTokens: number;
    defaultTopP: number;
  };
}

interface BusinessPersonalityResponse {
  success: boolean;
  data?: BusinessPersonalitySettings;
  botSettings?: BusinessPersonalitySettings;
  message?: string;
}

const createBusinessPersonalitySettings = async (businessNumber: string, wabaId: string, settings: Omit<BusinessPersonalitySettings, 'wabaId' | 'businessNumber'>): Promise<BusinessPersonalityResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: "/bot-settings",
    method: "POST",
    data: {
      businessNumber,
      wabaId,
      ...settings
    },
  });
  return response.data as BusinessPersonalityResponse;
};

const updateBusinessPersonalitySettings = async (businessNumber: string, wabaId: string, settings: Omit<BusinessPersonalitySettings, 'wabaId' | 'businessNumber'>): Promise<BusinessPersonalityResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: "/bot-settings",
    method: "PUT",
    data: {
      businessNumber,
      wabaId,
      ...settings
    },
  });
  return response.data as BusinessPersonalityResponse;
};

const getBusinessPersonalitySettings = async (businessNumber: string): Promise<BusinessPersonalityResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: "/bot-settings",
    method: "GET",
    params: { businessNumber },
  });
  return response.data as BusinessPersonalityResponse;
};

// WhatsApp Messages API
interface Message {
  customerName: string;
  mid: string;
  businessNumber: string;
  customerNumber: string;
  s3FilePath: string;
  timestamp: string;
}

interface MessagesResponse {
  success: boolean;
  messages: Message[];
  count: number;
  nextToken: string | null;
  scannedCount: number;
}

const getBusinessMessages = async (phoneNumberId: string): Promise<MessagesResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/messages/business-number/${encodeURIComponent(phoneNumberId)}`,
    method: "GET",
  });
  return response.data as MessagesResponse;
};

// WhatsApp Call Records API
interface WhatsAppCallRecord {
  customerName?: string;
  customerNumber: string;
  timestamp: string;
  duration?: number;
  type?: 'incoming' | 'outgoing';
  status?: 'completed' | 'missed' | 'failed';
  callId?: string;
  [key: string]: any;
}

interface WhatsAppCallRecordsResponse {
  success: boolean;
  count?: number;
  records?: WhatsAppCallRecord[];
  calls?: WhatsAppCallRecord[];
  data?: WhatsAppCallRecord[];
  [key: string]: any;
}

const getWhatsAppCallRecords = async (phoneNumberId?: string): Promise<WhatsAppCallRecordsResponse> => {
  try {
    const phoneId = phoneNumberId || sessionStorage.getItem('phoneNumberId');
    if (!phoneId) {
      return { success: false, calls: [], data: [] };
    }
    const url = `/whatsapp/call-records?phone_number_id=${encodeURIComponent(phoneId)}`;
    const response = await bookaMeetingApi.requestWIthAuth({
      url,
      method: "GET",
    });
    return response.data as WhatsAppCallRecordsResponse;
  } catch (error) {
    return { success: false, calls: [], data: [] };
  }
};

// Get call records from audio API (returns JSON with records)
const getCallRecordsFromAudioApi = async (businessNumber: string, callerId: string): Promise<WhatsAppCallRecordsResponse> => {
  try {
    const url = `/whatsapp/call-records/audio?business_number=${encodeURIComponent(businessNumber)}&caller_id=${encodeURIComponent(callerId)}`;
    const response = await bookaMeetingApi.requestWIthAuth({
      url,
      method: "GET",
      // Don't set responseType to blob - let it return JSON if available
    });
    // Check if response is JSON with records
    if (response.data && typeof response.data === 'object' && !(response.data instanceof Blob)) {
      const data = response.data as any;
      if (data.success !== undefined || data.records || data.calls || data.data) {
        return data as WhatsAppCallRecordsResponse;
      }
    }
    return { success: false, records: [], calls: [], data: [] };
  } catch (error) {
    return { success: false, records: [], calls: [], data: [] };
  }
};

// Get call audio by business_number and caller_id
const getCallAudio = async (businessNumber: string, callerId: string): Promise<string | null> => {
  try {
    const url = `/whatsapp/call-records/audio?business_number=${encodeURIComponent(businessNumber)}&caller_id=${encodeURIComponent(callerId)}`;
    const response = await bookaMeetingApi.requestWIthAuth({
      url,
      method: "GET",
      responseType: 'blob', // Request blob response for audio files
    });
    // Return the audio URL or blob URL
    if (response.data) {
      // If it's a blob, create object URL
      if (response.data instanceof Blob) {
        return URL.createObjectURL(response.data);
      }
      // If it's a URL string, return it
      if (typeof response.data === 'string') {
        return response.data;
      }
      // If it's an object with url property
      const data = response.data as any;
      if (data && typeof data === 'object' && 'url' in data) {
        return data.url;
      }
    }
    return null;
  } catch (error) {
    // Error fetching call audio - return null
    return null;
  }
};

// Customer History API
interface ConversationMessage {
  message: string;
  timestamp: string;
  messageId: string;
}

interface Conversation {
  messageId: string;
  left: ConversationMessage[];
  right: ConversationMessage[];
}

interface CustomerHistoryResponse {
  success: boolean;
  customerNumber: string;
  customerName: string;
  lastUpdated: string;
  bot_settings: boolean;
  nameHistory: Array<{
    oldName: string;
    newName: string;
    updatedAt: string;
    messageId: string;
  }>;
  conversations: Conversation[];
}

const getCustomerHistory = async (customerNumber: string, phoneNumberId: string): Promise<CustomerHistoryResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/customer-history`,
    method: "POST",
    data: {
      customerNumber,
      phone_number_id: phoneNumberId,
    },
  });
  return response.data as CustomerHistoryResponse;
};

const updateCount = async (customerNumber: string, phoneNumberId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/updateCount`,
    method: "POST",
    data: {
      customerNumber,
      phone_number_id: phoneNumberId,
    },
  });
  return response.data;
};

const sendMessage = async (phone: string, message: string, phoneNumberId: string, businessPhoneNumber?: string): Promise<any> => {
  // Add + prefix to customer phone number
  const customerPhone = phone.startsWith('+') ? phone : `+${phone}`;
  
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/send-message`,
    method: "POST",
    data: {
      customerPhone,
      message,
      businessPhoneNumberId: phoneNumberId,
      businessPhoneNumber: businessPhoneNumber || '',
      preview_url: false
    }
  });
  return response.data;
};

const getTemplatesList = async (wabaId: string, limit: number = 25, after?: string, before?: string): Promise<any> => {
  const params: any = { limit: limit.toString() };
  if (after) params.after = after;
  if (before) params.before = before;
  
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/list-templates/${wabaId}`,
    method: "GET",
    params
  });
  return response.data;
};

const getTemplateCounts = async (templateId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/template-counts/${templateId}`,
    method: "GET"
  });
  return response.data;
};

const createTemplate = async (wabaId: string, templateData: any): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/create-template/${wabaId}`,
    method: "POST",
    data: templateData
  });
  return response.data;
};

const updateTemplate = async (templateId: string, templateData: any): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/update-template/${templateId}`,
    method: "PATCH",
    data: templateData
  });
  return response.data;
};

const getTemplate = async (templateId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/template/${templateId}`,
    method: "GET"
  });
  return response.data;
};

const deleteTemplate = async (templateId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/delete-template/${templateId}`,
    method: "DELETE"
  });
  return response.data;
};

const getWhatsappAccount = async (email: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/whatsapp/${email}`,
    method: "GET"
  });
  return response.data;
};

const sendMarketingMessages = async (messageData: any, phoneNumberId?: string): Promise<any> => {
  // Get phoneNumberId from parameter, messageData, or session storage if not provided
  // This should be the WhatsApp Business Phone Number ID, not WABA ID
  const phoneId = phoneNumberId || messageData.phoneNumberId || sessionStorage.getItem('phoneNumberId');
  
  if (!phoneId) {
    throw new Error('WhatsApp Business Phone Number ID is required');
  }
  
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/send-marketing-message/${phoneId}`,
    method: "POST",
    data: messageData
  });
  return response.data;
};

const getPhoneGroups = async (wabaId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${wabaId}`,
    method: "GET"
  });
  return response.data;
};

const createGroup = async (groupData: { groupName: string; description: string; wabaId: string }): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups`,
    method: "POST",
    data: groupData
  });
  return response.data;
};

const updateGroup = async (groupId: string, groupData: { groupName: string; description: string }): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${groupId}`,
    method: "PUT",
    data: groupData
  });
  return response.data;
};

const deleteGroup = async (groupId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${groupId}`,
    method: "DELETE"
  });
  return response.data;
};

const uploadPhoneNumbers = async (groupId: string, file: File): Promise<any> => {
  // Helper function to create FormData (needed for retries since FormData can only be read once)
  const createFormData = () => {
    const formData = new FormData();
    formData.append('file', file);
    return formData;
  };
  
  // Helper function to make upload request with token refresh
  const makeUploadRequest = async (token: string, retry = false): Promise<any> => {
    // Recreate FormData for each request (especially important for retries)
    const formData = createFormData();
    
    const axiosInstance = axios.create({
      baseURL: baseURL,
      headers: {
        "authorization": `Bearer ${token}`,
        // Don't set Content-Type - let axios set it automatically for FormData
      },
    });
    
    try {
      const response = await axiosInstance.post(`/groups/${groupId}/upload`, formData);
      return response.data;
    } catch (error: any) {
      // Handle 401/403 errors - try to refresh token
      if (!retry && error.response && (error.response.status === 401 || error.response.status === 403)) {
        // Try to refresh the access token
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          throw new Error('No refresh token available');
        }
        
        try {
          const refreshResponse = await axios.post(`${baseURL}/refresh`, {
            refreshToken
          });
          
          if (refreshResponse.data && refreshResponse.data.accessToken) {
            const newToken = refreshResponse.data.accessToken;
            // Update the token cookie
            setCookie('token', newToken, 7);
            // Retry the upload with new token
            return makeUploadRequest(newToken, true);
          } else {
            throw new Error('Failed to refresh token');
          }
        } catch (refreshError) {
          // console.error('Upload: Token refresh failed:', refreshError);
          throw new Error('Failed to refresh authentication token');
        }
      }
      
      // Re-throw the error if it's not a 401/403 or if we already retried
      throw error;
    }
  };
  
  // Get current token and make request
  const token = getCookie('token');
  if (!token) {
    // Try to refresh first if no token
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      try {
        const refreshResponse = await axios.post(`${baseURL}/refresh`, {
          refreshToken
        });
        
        if (refreshResponse.data && refreshResponse.data.accessToken) {
          const newToken = refreshResponse.data.accessToken;
          setCookie('token', newToken, 7);
          return makeUploadRequest(newToken);
        }
      } catch (error) {
        // console.error('Upload: Failed to refresh token:', error);
        throw new Error('Authentication token is required');
      }
    } else {
      throw new Error('Authentication token is required');
    }
  }
  
  return makeUploadRequest(token);
};

const getGroupPhoneNumbers = async (groupId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${groupId}/phone-numbers`,
    method: "GET"
  });
  return response.data;
};

const getGroupPhoneNumbersAll = async (groupId: string): Promise<any> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${groupId}/phone-numbers/all`,
    method: "GET"
  });

  return response.data;
};

const deletePhoneNumber = async (groupId: string, phoneNumber: string): Promise<any> => {
  if (!groupId) {
    throw new Error('Group ID is required');
  }
  if (!phoneNumber) {
    throw new Error('Phone number is required');
  }
  
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${groupId}/phone-numbers/${phoneNumber}`,
    method: "DELETE"
  });
  return response.data;
};

const addManualPhoneNumbers = async (groupId: string, phoneNumbers: Array<{phoneNumber: string, name: string, status: string}>): Promise<any> => {
  if (!groupId) {
    throw new Error('Group ID is required');
  }
  
  // Get token from cookie and validate
  const token = getCookie('token');

  console.log('Token value (first 20 chars):', token ? token.substring(0, 20) + '...' : 'null');
  if (!token) {
    throw new Error('Authentication token is required. Please log in again.');
  }
  
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${groupId}/phone-numbers/manual`,
    method: "POST",
    data: {
      phoneNumbers: phoneNumbers.map(entry => ({
        phoneNumber: entry.phoneNumber,
        name: entry.name,
        status: entry.status
      }))
    }
  });
  return response.data;
};

const scheduleGroupMessage = async (groupId: string, templateId: string, triggerTime: string, timezone?: string): Promise<any> => {
  if (!groupId) {
    throw new Error('Group ID is required');
  }
  if (!templateId) {
    throw new Error('Template ID is required');
  }
  if (!triggerTime) {
    throw new Error('Trigger time is required');
  }
  
  const payload: any = {
    groupId,
    templateId,
    triggerTime
  };
  
  // Add timezone if provided
  if (timezone) {
    payload.timezone = timezone;
  }
  
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/schedule-message`,
    method: "POST",
    data: payload
  });
  return response.data;
};

const updatePasscode = async (newPasscode: string): Promise<any> => {
  // Get phoneNumberId from session storage
  const phoneNumberId = sessionStorage.getItem('phoneNumberId');
  if (!phoneNumberId) {
    throw new Error('Phone number ID not found in session storage');
  }
  
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/update-passcode/${phoneNumberId}`,
    method: "PUT",
    data: { passcode: newPasscode }
  });
  return response.data;
};

// Save or update phone number (backend handles create/update logic)
const savePhoneNumber = async (groupId: string, phoneNumberData: {
  phoneNumber: string;
  name?: string;
  status?: string;
  course?: string;
  date?: string;
  image?: string;
  [key: string]: any;
}): Promise<any> => {
  if (!groupId) {
    throw new Error('Group ID is required');
  }
  
  const token = getCookie('token');
  if (!token) {
    throw new Error('Authentication token is required. Please log in again.');
  }

  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/groups/${groupId}/phone-numbers`,
    method: "POST",
    data: {
      phoneNumbers: [{
        phoneNumber: phoneNumberData.phoneNumber,
        name: phoneNumberData.name || '',
        status: phoneNumberData.status || 'active',
        course: phoneNumberData.course || '',
        date: phoneNumberData.date || '',
        image: phoneNumberData.image || ''
      }]
    }
  });
  return response.data;
};

const refreshToken = async (): Promise<string | null> => {
  try {
    const refreshTokenValue = localStorage.getItem('refreshToken');
    if (!refreshTokenValue) {
      return null;
    }

    const response = await axios.post(`${baseURL}/refresh`, {
      refreshToken: refreshTokenValue
    });

    if (response.data && typeof response.data === 'object' && 'accessToken' in response.data) {
      const newAccessToken = (response.data as any).accessToken;
      // Update the token cookie
      setCookie('token', newAccessToken, 7);
      return newAccessToken;
    }
    
    return null;
  } catch (error) {
    // console.error('Error refreshing token:', error);
    return null;
  }
};

const saveFlow = async (flowData: {
  wabaId: string;
  flow_settings: any[];
  bot_settings: {
    enabled: boolean;
    name: string;
    description: string;
  };
  assign_groups: string[];
}): Promise<any> => {
  let token = getCookie('token');
  if (!token) {
    // Try to refresh token if missing
    const newToken = await refreshToken();
    if (newToken) {
      token = newToken;
    } else {
      throw new Error('Authentication token is required. Please log in again.');
    }
  }
  const response = await bookaMeetingApi.requestWIthAuth({
    url: '/flows/save',
    method: 'POST',
    data: flowData
  });
  return response.data;
};

const getFlowsByWabaId = async (wabaId: string): Promise<any> => {
  let token = getCookie('token');
  if (!token) {
    // Try to refresh token if missing
    const newToken = await refreshToken();
    if (newToken) {
      token = newToken;
    } else {
      throw new Error('Authentication token is required. Please log in again.');
    }
  }
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/flows/waba/${wabaId}`,
    method: 'GET'
  });
  return response.data;
};

// Phone Settings API
interface PhoneSettings {
  phoneNumber: string;
  tokenLimit: number;
  assignedTokens: number;
  token_key: string;
  system_prompt: string;
  idle_prompt: string;
  voice: string;
  caller_name: string;
  initial_instruction: string;
}

interface PhoneSettingsResponse {
  success: boolean;
  message?: string;
  data?: PhoneSettings;
}

const createPhoneSettings = async (phoneNumber: string, settings: PhoneSettings): Promise<PhoneSettingsResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: "/phone-settings",
    method: "POST",
    data: {
      phoneNumber,
      ...settings
    },
  });
  return response.data as PhoneSettingsResponse;
};

const updatePhoneSettings = async (phoneNumber: string, settings: PhoneSettings): Promise<PhoneSettingsResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: "/phone-settings",
    method: "PUT",
    data: {
      phoneNumber,
      ...settings
    },
  });
  return response.data as PhoneSettingsResponse;
};

const getPhoneSettings = async (phoneNumber: string): Promise<PhoneSettingsResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: "/phone-settings",
    method: "GET",
    params: { phoneNumber },
  });
  return response.data as PhoneSettingsResponse;
};

const getFlowById = async (flowId: string): Promise<any> => {
  let token = getCookie('token');
  if (!token) {
    // Try to refresh token if missing
    const newToken = await refreshToken();
    if (newToken) {
      token = newToken;
    } else {
      throw new Error('Authentication token is required. Please log in again.');
    }
  }
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/flows/${flowId}`,
    method: 'GET'
  });
  return response.data;
};

// Phone AI Voice Settings API
interface PhoneAIVoiceSettings {
  system_prompt?: string;
  idle_prompt?: string;
  voice?: string;
  tokenLimit?: number;
  assignedTokens?: number;
  token_key?: string;
  caller_name?: string;
  initial_instruction?: string;
  [key: string]: any;
}

interface PhoneAIVoiceSettingsResponse {
  success: boolean;
  message?: string;
  data?: any;
  phoneAiVoiceSettings?: {
    phoneNumber?: string;
    tokenLimit?: number;
    assignedTokens?: number;
    token_key?: string;
    system_prompt?: string;
    idle_prompt?: string;
    voice?: string;
    caller_name?: string;
    initial_instruction?: string;
    [key: string]: any;
  };
}

const savePhoneAIVoiceSettings = async (phoneId: string, settings: PhoneAIVoiceSettings): Promise<PhoneAIVoiceSettingsResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/phone-ai-voice-settings/${phoneId}`,
    method: "POST",
    data: settings,
  });
  return response.data as PhoneAIVoiceSettingsResponse;
};

const getPhoneAIVoiceSettings = async (phoneId: string): Promise<PhoneAIVoiceSettingsResponse> => {
  const response = await bookaMeetingApi.requestWIthAuth({
    url: `/phone-ai-voice-settings/${phoneId}`,
    method: "GET",
  });
  return response.data as PhoneAIVoiceSettingsResponse;
};

interface InitiateBusinessCallParams {
  phoneNumberId: string;
  to: string;
  recipientName: string;
}

interface InitiateBusinessCallResponse {
  success: boolean;
  data?: {
    success: boolean;
    callId?: string;
    message?: string;
  };
  message?: string;
}

const initiateBusinessCall = async (params: InitiateBusinessCallParams): Promise<InitiateBusinessCallResponse> => {
  try {
    const response = await axios.post(
      'https://api.frontdesk24.com/api/business-call',
      {
        phoneNumberId: params.phoneNumberId,
        to: params.to,
        recipientName: params.recipientName,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`,
        },
      }
    );
    return response.data as InitiateBusinessCallResponse;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || 'Failed to initiate business call',
    };
  }
};

interface LiveKitRoom {
  sid: string;
  name: string;
  emptyTimeout: number;
  departureTimeout: number;
  maxParticipants: number;
  creationTime: string;
  metadata: string;
  numParticipants: number;
  numPublishers: number;
}

interface ListLiveKitRoomsResponse {
  success: boolean;
  count: number;
  rooms: LiveKitRoom[];
}

const listLiveKitRooms = async (): Promise<ListLiveKitRoomsResponse> => {
  try {
    const response = await axios.get(
      'https://api.frontdesk24.com/api/list-livekit-rooms',
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`,
        },
      }
    );
    return response.data as ListLiveKitRoomsResponse;
  } catch (error: any) {
    logger.error('Error listing LiveKit rooms:', error);
    return {
      success: false,
      count: 0,
      rooms: [],
    };
  }
};

interface DocumentUploadResponse {
  success: boolean;
  phone_number_id: string;
  chunksStored: number;
  pages: number;
}

interface DocumentListResponse {
  success: boolean;
  phone_number_id: string;
  hasDocuments: boolean;
  chunkCount: number;
  documents?: Array<{
    id: string;
    fileName: string;
    uploadDate: string;
    fileSize: number;
    pages: number;
    chunksStored: number;
  }>;
}

const testBotReply = async (input: {
  channel: 'whatsapp' | 'instagram';
  text: string;
  phoneNumberId?: string;
  businessNumber?: string;
  wabaId?: string;
  instagramBusinessId?: string;
}): Promise<{ success?: boolean; reply?: string; error?: string }> => {
  try {
    const response = await axios.post(
      'https://api.frontdesk24.com/api/bot/test',
      input,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    logger.error('Error testing bot:', error);
    throw new Error(error?.response?.data?.error || error?.message || 'Could not test the bot');
  }
};

const saveKnowledgeVectors = async (file: File, phoneNumberId: string): Promise<DocumentUploadResponse> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('phone_number_id', phoneNumberId);

    const response = await axios.post(
      'https://api.frontdesk24.com/api/knowledge/vectors',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${getCookie('token')}`,
        },
      }
    );
    return response.data as DocumentUploadResponse;
  } catch (error: any) {
    logger.error('Error saving knowledge vectors:', error);
    throw new Error(error?.response?.data?.error || error?.message || 'Failed to save knowledge');
  }
};

const uploadDocument = async (file: File, phoneNumberId: string): Promise<DocumentUploadResponse> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('phone_number_id', phoneNumberId);

    const response = await axios.post(
      'https://api.frontdesk24.com/api/documents/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${getCookie('token')}`,
        },
      }
    );
    return response.data as DocumentUploadResponse;
  } catch (error: any) {
    logger.error('Error uploading document:', error);
    throw new Error(error?.response?.data?.message || error?.message || 'Failed to upload document');
  }
};

const listDocuments = async (phoneNumberId: string): Promise<DocumentListResponse> => {
  try {
    const response = await axios.get(
      `https://api.frontdesk24.com/api/documents?phone_number_id=${phoneNumberId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`,
        },
      }
    );
    return response.data as DocumentListResponse;
  } catch (error: any) {
    logger.error('Error listing documents:', error);
    return {
      success: false,
      phone_number_id: phoneNumberId,
      hasDocuments: false,
      chunkCount: 0,
    };
  }
};

const deleteDocument = async (phoneNumberId: string): Promise<{ success: boolean; message?: string }> => {
  try {
    const response = await axios.delete(
      `https://api.frontdesk24.com/api/documents?phone_number_id=${phoneNumberId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`,
        },
      }
    );
    return response.data || { success: true };
  } catch (error: any) {
    logger.error('Error deleting document:', error);
    throw new Error(error?.response?.data?.message || error?.message || 'Failed to delete document');
  }
};

export {signIn, signUp, signUpWithPhone, signInWithPhone, getEmbeddedSignupByPhone, createBusinessPersonalitySettings, updateBusinessPersonalitySettings, getBusinessPersonalitySettings, getBusinessMessages, getCustomerHistory, updateCount, sendMessage, getTemplatesList, getTemplateCounts, createTemplate, updateTemplate, getTemplate, deleteTemplate, getWhatsappAccount, sendMarketingMessages, getPhoneGroups, createGroup, updateGroup, deleteGroup, uploadPhoneNumbers, getGroupPhoneNumbers, getGroupPhoneNumbersAll, deletePhoneNumber, scheduleGroupMessage, addManualPhoneNumbers, updatePasscode, savePhoneNumber, saveFlow, getFlowsByWabaId, getFlowById, refreshToken, createPhoneSettings, updatePhoneSettings, getPhoneSettings, savePhoneAIVoiceSettings, getPhoneAIVoiceSettings, getWhatsAppCallRecords, getCallAudio, getCallRecordsFromAudioApi, initiateBusinessCall, listLiveKitRooms, uploadDocument, saveKnowledgeVectors, testBotReply, listDocuments, deleteDocument}